import {pi, tau} from "../math.js";

export default {
  draw: function(context, size) {
    var r = Math.sqrt(size / pi);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, tau);
  }
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-shape/src/symbol/circle.js
// module id = M8zP
// module chunks = 0